"use strict";

function _interopDefault(e) {
  return e && "object" == typeof e && "default" in e ? e.default : e;
}
Object.defineProperty(exports, "__esModule", {
  value: !0
});
var React = require("react"),
  React__default = _interopDefault(React);
function _typeof(e) {
  return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  })(e);
}
function _slicedToArray(e, t) {
  return _arrayWithHoles(e) || _iterableToArrayLimit(e, t) || _nonIterableRest();
}
function _arrayWithHoles(e) {
  if (Array.isArray(e)) return e;
}
function _iterableToArrayLimit(e, t) {
  var r = [],
    o = !0,
    n = !1,
    a = void 0;
  try {
    for (var i, u = e[Symbol.iterator](); !(o = (i = u.next()).done) && (r.push(i.value), !t || r.length !== t); o = !0);
  } catch (e) {
    n = !0, a = e;
  } finally {
    try {
      o || null == u.return || u.return();
    } finally {
      if (n) throw a;
    }
  }
  return r;
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function createCommonjsModule(e, t) {
  return e(t = {
    exports: {}
  }, t.exports), t.exports;
}
var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED",
  ReactPropTypesSecret_1 = ReactPropTypesSecret;
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
var factoryWithThrowingShims = function factoryWithThrowingShims() {
    function e(e, t, r, o, n, a) {
      if (a !== ReactPropTypesSecret_1) {
        var i = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw i.name = "Invariant Violation", i;
      }
    }
    function t() {
      return e;
    }
    var r = {
      array: e.isRequired = e,
      bool: e,
      func: e,
      number: e,
      object: e,
      string: e,
      symbol: e,
      any: e,
      arrayOf: t,
      element: e,
      elementType: e,
      instanceOf: t,
      node: e,
      objectOf: t,
      oneOf: t,
      oneOfType: t,
      shape: t,
      exact: t,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    return r.PropTypes = r;
  },
  propTypes = createCommonjsModule(function (e) {
    e.exports = factoryWithThrowingShims();
  }),
  StateProvider = function StateProvider(e) {
    var t = e.reducer,
      r = e.stateContext,
      o = e.children;
    if ("function" != typeof t) throw new Error("The reducer must be a function. You might have forgotten to pass your reducer into your StateProvider.");
    if (!r) throw new Error("stateContext prop is undefined. Please check your createContext method and what you are passing into your StateProvider.");
    if (void 0 === o || "object" !== _typeof(o) || !Object.keys(o).length) throw new Error("StateProvider must contain children components. You probably forgot to wrap it around your components in your JSX.");
    var n = t(void 0, {
        type: "@conflux".concat(Math.random().toString(36).substring(7))
      }),
      a = _slicedToArray(React.useReducer(t, n), 2),
      i = a[0],
      u = a[1],
      c = React.useMemo(function () {
        return [i, u];
      }, [i]),
      s = r.Provider;
    return React__default.createElement(s, {
      value: c
    }, o);
  };
StateProvider.propTypes = {
  reducer: propTypes.func.isRequired,
  stateContext: propTypes.object.isRequired,
  children: propTypes.oneOfType([propTypes.element, propTypes.array]).isRequired
};
var useStateValue = function useStateValue(e) {
  if (void 0 === e) throw new Error("The stateContext object is undefined in your useStateValue hook. You probably forgot to pass the stateContext object into your useStateValue hook.");
  if (!e.Provider && !e.Consumer) throw new Error("Incorrect argument passed to the useStateValue hook. You probably passed a variable other than your context object into it.");
  var t = React.useContext(e);
  if (void 0 === t) throw new Error("The useStateValue hook must be used within the Provider of the Context object you have passed to it. Check to make sure you have passed in the correct context object and that the useStateValue hook is within a child of the correct Provider.");
  return t;
};
exports.StateProvider = StateProvider, exports.useStateValue = useStateValue;